<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<lms-message-tab *ngIf="selectedTab && selectedTab.subTypeDetail?.profile?.status === 'error' && selectedTab.subTypeDetail?.profile?.message" [message]="selectedTab && selectedTab.subTypeDetail?.profile.message" (clearMessage)="clearErrorMessage($event)"></lms-message-tab>
<div class="clear"></div>
<div id="top-actions">
    <div class="top-actions">
        <div class="loco-container">
            <span *ngIf="selectedTab?.subTypeDetail[selectedTab.subType.toLowerCase()]?.status !== 'loaded'" class="loco-na-icon">NA</span>
            <span *ngIf="selectedTab?.subTypeDetail[selectedTab.subType.toLowerCase()]?.status === 'loaded'" class="locoIcon-warning">{{selectedTab?.tabSearchParameter?.searchText}}</span>
        </div>
        <lms-header-sub-types [subTypes]="subTypes" [tab]="selectedTab" [tabIndex]='tabLevel'></lms-header-sub-types>
    </div>
    <div class="pfl-tab-sticky-data" *ngIf="false && loadData && selectedTab && selectedTab.subTypeDetail && selectedTab.subTypeDetail.profile?.status  == 'loaded'">
        <div class="legends">
            <div class="yellow-box"> <span></span> {{profileLabel.helperSegment}}</div>
            <div class="green-box"> <span></span> {{profileLabel.restrictiveSegment}}</div>
            <div class="green-bdr"> <span></span> {{profileLabel.restrictiveHelperSegment}}</div>
            <div class="calc-expand">
                <button class="{{isTonnageCapacityShown?'calculator':''}}" type="button" (click)="showTonnageCapacityCalculation();">{{profileLabel.calculator}}</button>
                <button type="button" (click)="expandCollapseTree();"> <span class="add-icon">{{exColLabelSign}}</span> {{exColLabel}}</button>
            </div>
        </div>
        <div class="selected-tbl-cols" *ngIf='isTonnageCapacityShown'>
            <textarea spellcheck="false" disabled pInputTextarea [(ngModel)]="calculatorHeading" placeholder="{{profileLabel.clickOnCommonHeading}}" rows="1"></textarea>
            <div class="clear-all-links">
                <button type="button" (click)="clearPreviousCalulationValue();">{{profileLabel.clear}}</button>
                <span>|</span>
                <button type="button" (click)="clearAllCalulatedValue();">{{profileLabel.clearAll}}</button>
            </div>
        </div>
        <div class="{{isTonnageCapacityShown ? 'pfl-tree-table scn-calc':'pfl-tree-table'}}">
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <th class="col-1">{{profileLabel.level}}</th>
                        <th class="col-2">{{profileLabel.departTime}}</th>
                        <th class="col-3">{{profileLabel.arriveTime}}</th>
                        <th class="text-pull-center col-4">{{profileLabel.miles}}</th>
                        <th class="text-pull-center blue-header border-thick-left col-5">{{profileLabel.helpers}}</th>
                        <th class="blue-header helper-consist-left col-6">{{profileLabel.helperConsist}}</th>
                        <th class="blue-header v-top border-thick-left col-7">
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td><button type="button" class="colum-btn {{!isTonnageCapacityShown?'tonnageCaps':''}}" (click)='addColumnsNeededToCalculateTonnageCapacity(profileLabel.A);'>{{profileLabel.A}}</button>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="v-bottom">
                                        <div class="lines-header">
                                            <p><span>{{profileLabel.MP15}}</span><button type="text" class='more-classes' (click)="opA.toggle($event)">+</button></p>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <p-overlayPanel class="classes-overlay" #opA>
                                <p><span>{{profileLabel.MP15T}}</span></p>
                                <p><span>{{profileLabel.GP151}}</span></p>
                                <p><span>{{profileLabel.GP15T}}</span></p>
                            </p-overlayPanel>
                        </th>

                        <th class="blue-header v-top text-pull-center col-8">
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td><button type="button" class="colum-btn {{!isTonnageCapacityShown?'tonnageCaps':''}}" (click)='addColumnsNeededToCalculateTonnageCapacity(profileLabel.B);'>{{profileLabel.B}}</button>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="v-bottom">
                                        <div class="lines-header">
                                            <p><span>{{profileLabel.GP402}}</span><button type="text" class='more-classes' (click)="opB.toggle($event)">+</button></p>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <p-overlayPanel class="classes-overlay" #opB>
                                <p><span>{{profileLabel.GS21B}}</span></p>
                                <p><span>{{profileLabel.B208}}</span></p>
                                <p><span>{{profileLabel.B408}}</span></p>
                                <p><span>{{profileLabel.GP382}}</span></p>
                            </p-overlayPanel>
                        </th>

                        <th class="blue-header v-top text-pull-center col-9">
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td><button type="button" class=" colum-btn {{!isTonnageCapacityShown?'tonnageCaps':''}}" (click)='addColumnsNeededToCalculateTonnageCapacity(profileLabel.C);'>{{profileLabel.C}}</button></td>
                                </tr>
                                <tr>
                                    <td class="v-bottom">
                                        <div class="lines-header">
                                            <p><span>{{profileLabel.SD402}}</span><button type="text" class='more-classes' (click)="opC.toggle($event)">+</button></p>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <p-overlayPanel class="classes-overlay" #opC>
                                <p><span>{{profileLabel.SD502}}</span></p>
                                <p><span>{{profileLabel.SD503}}</span></p>
                            </p-overlayPanel>
                        </th>

                        <th class="blue-header v-top text-pull-center col-10">
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td><button type="button" class=" colum-btn {{!isTonnageCapacityShown?'tonnageCaps':''}}" (click)='addColumnsNeededToCalculateTonnageCapacity(profileLabel.D);'>{{profileLabel.D}}</button></td>
                                </tr>
                                <tr>
                                    <td class="v-bottom">
                                        <div class="lines-header">
                                            <p><span>{{profileLabel.SD50}}</span></p>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </th>
                        <th class="blue-header v-top text-pull-center col-11">
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td><button type="button" class="colum-btn {{!isTonnageCapacityShown?'tonnageCaps':''}}" (click)='addColumnsNeededToCalculateTonnageCapacity(profileLabel.E);'>{{profileLabel.E}}</button></td>
                                </tr>
                                <tr>
                                    <td class="v-bottom">
                                        <div class="lines-header">
                                            <p><span>{{profileLabel.CW408}}</span><button type="text" class='more-classes' (click)="opE.toggle($event)">+</button></p>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <p-overlayPanel class="classes-overlay" #opE>
                                <p><span>{{profileLabel.SD70M}}</span></p>
                                <p><span>{{profileLabel.SD60}}</span></p>
                                <p><span>{{profileLabel.CW449}}</span></p>
                                <p><span>{{profileLabel.C408}}</span></p>
                                <p><span>{{profileLabel.CW409}}</span></p>
                            </p-overlayPanel>
                        </th>

                        <th class="blue-header v-top text-pull-center col-12">
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td><button type="button" class="colum-btn {{!isTonnageCapacityShown?'tonnageCaps':''}}" (click)='addColumnsNeededToCalculateTonnageCapacity(profileLabel.F);'>{{profileLabel.F}}</button></td>
                                </tr>
                                <tr>
                                    <td class="v-bottom">
                                        <div class="lines-header">
                                            <p><span>{{profileLabel.ES40DC}}</span><button type="text" class='more-classes' (click)="opF.toggle($event)">+</button></p>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <p-overlayPanel class="classes-overlay" #opF>
                                <p><span>{{profileLabel.ES44DC}}</span></p>
                                <p><span>{{profileLabel.ES44C4}}</span></p>
                                <p><span>{{profileLabel.ET44C4}}</span></p>
                            </p-overlayPanel>
                        </th>

                        <th class="blue-header v-top text-pull-center col-13">
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td><button type="button" class="colum-btn {{!isTonnageCapacityShown?'tonnageCaps':''}}" (click)='addColumnsNeededToCalculateTonnageCapacity(profileLabel.G);'>{{profileLabel.G}}</button></td>
                                </tr>
                                <tr>
                                    <td class="v-bottom">
                                        <div class="lines-header">
                                            <p><span>{{profileLabel.SD70AC}}</span><button type="text" class='more-classes' (click)="opG.toggle($event)">+</button></p>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <p-overlayPanel class="classes-overlay" #opG>
                                <p><span>{{profileLabel.SD70AE}}</span></p>
                                <p><span>{{profileLabel.SD70MA}}</span></p>
                            </p-overlayPanel>
                        </th>

                        <th class="blue-header v-top text-pull-center col-14">
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td><button type="button" class="colum-btn {{!isTonnageCapacityShown?'tonnageCaps':''}}" (click)='addColumnsNeededToCalculateTonnageCapacity(profileLabel.H);'>{{profileLabel.H}}</button></td>
                                </tr>
                                <tr>
                                    <td class="v-bottom">
                                        <div class="lines-header">
                                            <p><span>{{profileLabel.CW44AC}}</span><button type="text" class='more-classes' class='more-classes' (click)="opH.toggle($event)">+</button></p>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <p-overlayPanel class="classes-overlay" #opH>
                                <p><span>{{profileLabel.CW46AC}}</span></p>
                                <p><span>{{profileLabel.CW446}}</span></p>
                                <p><span>{{profileLabel.CW60AC}}</span></p>
                                <p><span>{{profileLabel.ET44AC}}</span></p>
                                <p><span>{{profileLabel.SD80AC}}</span></p>
                                <p><span>{{profileLabel.SD90AC}}</span></p>
                            </p-overlayPanel>
                        </th>

                        <th class="blue-header v-top text-pull-center col-15">
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td><button type="button" class="colum-btn {{!isTonnageCapacityShown?'tonnageCaps':''}}" (click)='addColumnsNeededToCalculateTonnageCapacity(profileLabel.I);'>{{profileLabel.I}}</button></td>
                                </tr>
                                <tr>
                                    <td class="v-bottom">
                                        <div class="lines-header">
                                            <p><span>{{profileLabel.ES44AH}}</span><button type="text" class='more-classes' (click)="opI.toggle($event)">+</button></p>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <p-overlayPanel class="classes-overlay" #opI>
                                <p><span>{{profileLabel.CW44AH}}</span></p>
                                <p><span>{{profileLabel.CW46AH}}</span></p>
                                <p><span>{{profileLabel.CW60AH}}</span></p>
                                <p><span>{{profileLabel.ET44AH}}</span></p>
                            </p-overlayPanel>
                        </th>

                        <th class="{{!isTonnageCapacityShown?'tonnage-col text-pull-center text-pull-center col-16 tonnageCaps': 'tonnage-col text-pull-center text-pull-center col-16'}}">{{profileLabel.tonnageCapacity}}</th>
                        <th class="text-pull-center text-pull-center border-thick-left col-17">{{profileLabel.projectedTonnage}}</th>
                        <th class="text-pull-center text-pull-center col-18">
                            <p>{{profileLabel.historicalTonnageA}}</p>
                            <p>{{profileLabel.historicalTonnageB}}</p>
                        </th>
                    </tr>
                </thead>
            </table>

        </div>
    </div>
</div>
<div *ngIf="selectedTab && selectedTab.subTypeDetail && selectedTab.subTypeDetail.profile?.status  == 'blank'" class="page-helper-text">
    {{profileLabel.searchTrainProfile}}
</div>
<div *ngIf="selectedTab && selectedTab.subTypeDetail && selectedTab.subTypeDetail.profile?.status  == 'error' &&'Train ID is not a valid CSX format'===selectedTab?.subTypeDetail?.profile?.message" class="page-helper-text color-red">
    {{profileLabel.validTrainProfileId}}
</div>
<div class="clearfix"></div>
<div class="train-pfl-page" *ngIf="false && loadData && selectedTab && selectedTab.subTypeDetail && selectedTab.subTypeDetail.profile?.status  == 'loaded'">
    <div class="{{isTonnageCapacityShown ? 'pfl-tree-table scn-calc':'pfl-tree-table'}}">
        <p-treeTable [value]="loadData.profileData" (onNodeExpand)="openNode()" (onNodeCollapse)="closeNode()">

            <!-- New Format START -->
            <!-- <ng-template pTemplate="header">
                <tr>
                    <th>Level</th>
                    <th>Depart / Time</th>
                    <th>Arrive / Time</th>
                    <th>Miles</th>
                    <th>Helpers</th>
                    <th>Helper Consist</th>
                    <th>MP15</th>
                    <th>GP40-2</th>
                    <th>SD40-2</th>
                    <th>SD50</th>
                    <th>CW40-8</th>
                    <th>ES40DC</th>
                    <th>SD70AC</th>
                    <th>CW44AC</th>
                    <th>ES44AH</th>
                    <th>Projected Tons</th>
                    <th>Historical Tons 80th Percentile</th>
                </tr>
            </ng-template> -->
            <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                <tr class="p-treetable-row"
                    [class.has-parent]="rowNode.node.parent != null"
                    [class.has-children]="rowNode.node.children && rowNode.node.children.length > 0">
                    <td class="col-1">
                        <!-- Level -->
                        <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                        {{rowData.level}}
                    </td>
                    <td class="col-2 text-center">
                        <!-- Depart time -->
                        <span>{{rowData.departMnemonic}}<i *ngIf="rowData.departTime">,</i><br class="line-break-arrive">{{rowData.departTime}}
                        </span>
                    </td>
                    <td class="col-3 text-center">
                        <!-- Arrive time -->
                        <div class="{{rowData.arriveClass}}">
                            <span>{{rowData.arriveMnemonic}}<i *ngIf="rowData.arriveTime">,</i><br class="line-break-arrive">{{rowData.arriveTime}}
                            </span>
                        </div>
                    </td>
                    <td class="text-pull-center col-4">
                        <!-- Miles -->
                        {{rowData.miles}}
                    </td>

                    <td class="blue-header text-pull-center border-thick-left col-5">
                        <!-- Helpers -->
                        <div class="{{rowData.legend}}">
                            <span>{{rowData.helpers|locoBlankString}}</span>
                        </div>
                    </td>
                    <td class="blue-header helper-consist-left col-6">
                        <!-- Helper Consist -->
                        <div class="{{rowData.legend}}">
                            <span>{{rowData.helperUnit1?rowData.helperUnit1+': '+rowData.helperConsist1:''}}</span>
                            <span>{{rowData.helperUnit2?rowData.helperUnit2+': '+rowData.helperConsist2:''}}</span>
                            <span>{{rowData.helperUnit3?rowData.helperUnit3+': '+rowData.helperConsist3:''}}</span>
                        </div>
                    </td>
                    <td class="blue-header v-top text-pull-center border-thick-left col-7">
                        <!-- MP15 -->
                        <div class="{{rowData.legend}}">
                            <span>{{rowData.tonnageRating0 ? ('0'===rowData.tonnageRating0)?'-':rowData.tonnageRating0 :'-'}}</span>
                        </div>
                    </td>
                    <td class="blue-header v-top text-pull-center col-8">
                        <!-- GP40-2 -->
                        <div class="{{rowData.legend}}">
                            <span>{{rowData.tonnageRating1 ? ('0'===rowData.tonnageRating1)?'-':rowData.tonnageRating1 :'-'}}</span>
                        </div>
                    </td>
                    <td class="blue-header v-top text-pull-center col-9">
                        <!-- SD40-2 -->
                        <div class="{{rowData.legend}}">
                            <span>{{rowData.tonnageRating2 ? ('0'===rowData.tonnageRating2)?'-':rowData.tonnageRating2 :'-'}}</span>
                        </div>
                    </td>
                    <td class="blue-header v-top text-pull-center col-10">
                        <!-- SD50 -->
                        <div class="{{rowData.legend}}">
                            <span>{{rowData.tonnageRating3 ? ('0'===rowData.tonnageRating3)?'-':rowData.tonnageRating3 :'-'}}</span>
                        </div>
                    </td>
                    <td class="blue-header v-top text-pull-center col-11">
                        <!-- CW40-8 -->
                        <div class="{{rowData.legend}}">
                            <span>{{rowData.tonnageRating4 ? ('0'===rowData.tonnageRating4)?'-':rowData.tonnageRating4 :'-'}}</span>
                        </div>
                    </td>
                    <td class="blue-header v-top text-pull-center col-12">
                        <!-- ES40DC -->
                        <div class="{{rowData.legend}}">
                            <span>{{rowData.tonnageRating5 ? ('0'===rowData.tonnageRating5)?'-':rowData.tonnageRating5 :'-'}}</span>
                        </div>
                    </td>
                    <td class="blue-header v-top text-pull-center col-13">
                        <!-- SD70AC -->
                        <div class="{{rowData.legend}}">
                            <span>{{rowData.tonnageRating6 ? ('0'===rowData.tonnageRating6)?'-':rowData.tonnageRating6 :'-'}}</span>
                        </div>
                    </td>
                    <td class="blue-header v-top text-pull-center col-14">
                        <!-- CW44AC -->
                        <div class="{{rowData.legend}}">
                            <span>{{rowData.tonnageRating7 ? ('0'===rowData.tonnageRating7)?'-':rowData.tonnageRating7 :'-'}}</span>
                        </div>
                    </td>
                    <td class="blue-header v-top text-pull-center col-15">
                        <!-- ES44AH -->
                        <div class="{{rowData.legend}}">
                            <span>{{rowData.tonnageRating8 ? ('0'===rowData.tonnageRating8)?'-':rowData.tonnageRating8 :'-'}}</span>
                        </div>
                    </td>
                    <td class="tonnage-col text-pull-center text-pull-center col-16" *ngIf="isTonnageCapacityShown?'tonnageCaps':''">
                        <!-- Unknown extra conditional col -->
                        <span>{{''===rowData.tonnageCapacity ||0===rowData.tonnageCapacity?'-':rowData.tonnageCapacity}}</span>
                    </td>
                    <td class="text-pull-center text-pull-center border-thick-left col-17">
                        <!-- Projected Tons -->
                        {{rowData.projectedTons}}
                    </td>
                    <td class="text-pull-center text-pull-center col-18">
                        <!-- Historical Tons 80th Percentile -->
                        <div [class.bg-green]="rowData.historicalColor === 'Y'">
                            <span>{{rowData.historicalTons80 | locoBlankString}}</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <!-- New Format END -->

        </p-treeTable>
    </div>
</div>
<lms-lms-tonnage></lms-lms-tonnage>
